var map = {
	"./1.jpg": 14161,
	"./IMG_0847.JPG": 92011,
	"./IMG_0848.JPG": 79839,
	"./IMG_0849.JPG": 7740,
	"./IMG_0850.JPG": 13967,
	"./IMG_0851.JPG": 49439,
	"./IMG_0852.JPG": 62459,
	"./IMG_1234.JPG": 72026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84449;